import { CommCodeModel } from '@common/ProgramRegistration/model';
import api from './api';
import * as types from './mutation-types';

export default {
	fetchPrograms_: ({ state, commit }, payload) => {
		return api
			.fetchPrograms(payload)
			.then(data => {
				const { header, body } = data;
				const { code, message } = header;
				const { pagingInfo, resultList } = body;
				if (code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'pagingInfo',
						value: pagingInfo
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'programs',
						value: resultList
					});
				} else if (code === 3) {
					throw new Error(message);
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	fetchPgmIds_: ({ state, commit }, payload) => {
		return api
			.fetchPgmIds(payload)
			.then(data => {
				const { header, body } = data;
				const { code, message } = header;
				if (code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'selectOptions',
						value: {
							...state.selectOptions,
							pgmIds: body.sort((a, b) => a.value - b.value)
						}
					});
				} else if (code === 3) {
					throw new Error(message);
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	fetchPlants_: ({ state, commit }) => {
		return api
			.fetchPlants()
			.then(data => {
				const { header, body } = data;
				const { code, message } = header;
				if (code === 0) {
					const plants = body.map(commCode => new CommCodeModel(commCode));
					commit(types.DEFAULT_ASSIGN, {
						key: 'selectOptions',
						value: {
							...state.selectOptions,
							plants
						}
					});
				} else if (code === 3) {
					throw new Error(message);
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	fetchShopCds_: ({ state, commit }, payload) => {
		return api
			.fetchShopCds(payload)
			.then(data => {
				const { header, body } = data;
				const { code, message } = header;
				if (code === 0) {
					const shopCds = body.map(commCode => new CommCodeModel(commCode));
					commit(types.DEFAULT_ASSIGN, {
						key: 'selectOptions',
						value: {
							...state.selectOptions,
							shopCds
						}
					});
				} else if (code === 3) {
					throw new Error(message);
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	fetchServiceKinds_: ({ state, commit }, payload) => {
		return api
			.fetchServiceKinds(payload)
			.then(data => {
				const { header, body } = data;
				const { code, message } = header;
				if (code === 0) {
					const serviceKinds = body.map(commCode => new CommCodeModel(commCode));
					commit(types.DEFAULT_ASSIGN, {
						key: 'selectOptions',
						value: {
							...state.selectOptions,
							serviceKinds
						}
					});
				} else if (code === 3) {
					throw new Error(message);
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	fetchPgmTypes_: ({ state, commit }, payload) => {
		return api
			.fetchPgmTypes(payload)
			.then(data => {
				const { header, body } = data;
				const { code, message } = header;
				if (code === 0) {
					const pgmTypes = body.map(commCode => new CommCodeModel(commCode));
					commit(types.DEFAULT_ASSIGN, {
						key: 'selectOptions',
						value: {
							...state.selectOptions,
							pgmTypes
						}
					});
				} else if (code === 3) {
					throw new Error(message);
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	fetchLines_: ({ state, commit }, payload) => {
		return api
			.fetchLines(payload)
			.then(data => {
				const { header, body } = data;
				const { code, message } = header;
				if (code === 0) {
					const lines = body.map(commCode => new CommCodeModel(commCode));
					commit(types.DEFAULT_ASSIGN, {
						key: 'selectOptions',
						value: {
							...state.selectOptions,
							lines
						}
					});
				} else if (code === 3) {
					throw new Error(message);
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	fetchMainFlgs_: ({ state, commit }, payload) => {
		return api
			.fetchMainFlgs(payload)
			.then(data => {
				const { header, body } = data;
				const { code, message } = header;
				if (code === 0) {
					const mainFlgs = body.map(commCode => new CommCodeModel(commCode));
					commit(types.DEFAULT_ASSIGN, {
						key: 'selectOptions',
						value: {
							...state.selectOptions,
							mainFlgs
						}
					});
				} else if (code === 3) {
					throw new Error(message);
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	fetchExeEnvs_: ({ state, commit }, payload) => {
		return api
			.fetchExeEnvs(payload)
			.then(data => {
				const { header, body } = data;
				const { code, message } = header;
				if (code === 0) {
					const exeEnvs = body.map(commCode => new CommCodeModel(commCode));
					commit(types.DEFAULT_ASSIGN, {
						key: 'selectOptions',
						value: {
							...state.selectOptions,
							exeEnvs
						}
					});
				} else if (code === 3) {
					throw new Error(message);
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	createProgram_: ({ state, commit }, payload) => {
		return api
			.createProgram(payload)
			.then(data => {
				const { header } = data;
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	updateProgram_: ({ state, commit }, payload) => {
		return api
			.updateProgram(payload)
			.then(data => {
				const { header } = data;
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	deleteProgram_: ({ state, commit }, { program }) => {
		return api
			.deleteProgram(program)
			.then(data => {
				const { header } = data;
				return header;
			})
			.catch(error => {
				throw error;
			});
	}
};
